// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import "./spent_table.css";
// import { dummydata } from "../../data/dummydata";
// import { contractAddress, contractAddressAbi } from "../utils/contractaddress";
// import { usdtTokenAdd, usdtTokenAbi } from "../utils/contractUsdtToken";
// import {
//   usdaceTokenAdd,
//   usdaceTokenAddAbi,
// } from "../utils/contractUsdaceToken";
// import { useTranslation } from "react-i18next";
// import Web3 from "web3";
// const web3Supply = new Web3("https://bsc-dataseed1.binance.org/");

// const Spent_Table = () => {
//   const { t, i18n } = useTranslation();
//   const [roundNumber, setRoundNumber] = useState(0);
//   const [spendData, setSpendData] = useState([]);
//   const [commissionHistory, setCommissionHistory] = useState([
//     {
//       txid: "0",
//       usdtValue: "0",
//       usdaceValue: "0",
//     },
//   ]);
//   const [totalCommEarn, setTotalCommEarn] = useState(0);
//   const { acc } = useSelector((state) => state.connect);
//   // let acc = "0x70C0Fb7462F6658A9d4D7d6Af2d2e0C1fD8CE365";
//   useEffect(() => {
//     const getTotalCommEarn = async () => {
//       try {
//         const web3 = window.web3;
//         if (acc == "No Wallet") {
//           console.log("No Wallet");
//         } else if (acc == "Wrong Network") {
//           console.log("Wrong Wallet");
//         } else if (acc == "Connect Wallet") {
//           console.log("Connect Wallet");
//         } else {
//           const contract = new web3.eth.Contract(
//             contractAddressAbi,
//             contractAddress
//           );
//           let totalEarned = await contract.methods.totalEarned(acc).call();
//           console.log("totalEarned", totalEarned._TotalUSDACEEarned);
//           setCommissionHistory({
//             usdtValue: web3.utils.fromWei(totalEarned._TotalUSDTEarned),
//             usdaceValue: web3.utils.fromWei(totalEarned._TotalUSDACEEarned),
//           });
//           // const commissionHistoryUSDT = await contract.methods
//           //   .totalUSDTCommission(acc)
//           //   .call();
//           // const commissionHistoryUSACE = await contract.methods
//           //   .totalUSDACECommission(acc)
//           //   .call();
//           // const history = Object.keys(commissionHistory).map((key, index) => ({
//           //   txid: key,
//           //   usdtValue: web3.utils.fromWei(commissionHistoryUSDT, "ether"),
//           //   usdaceValue: web3.utils.fromWei(commissionHistoryUSACE, "ether"),
//           // }));
//           // setCommissionHistory(history);
//           // console.log("Commission history:", history);
//         }
//       } catch (e) {
//         console.log("Error", e);
//       }
//     };
//     getTotalCommEarn();
//   }, [acc]);
//   const getData = async () => {
//     try {
//       let contract = new web3Supply.eth.Contract(
//         contractAddressAbi,
//         contractAddress
//       );
//       let roundNo = await contract.methods.round().call();

//       setRoundNumber(roundNo);
//       console.log("print round", roundNo);
//     } catch (e) {
//       console.log("Error While Buying Tokens", e);
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, []);
//   return (
//     <div>
//       <>
//         <div className="container col-md-10 col-lg-10 col-xxl-12 py-md-4 py-4 text-primay_globle">
//           <div className="row d-flex align-items-center justify-content-center">
//             {/* <div className="col-12 col-md-12 col-xxl-12">
//               <h1 className="display-4 ">{t("withdrawHistory")}</h1>
//             </div> */}
//             <div className="col-12 col-md-12 col-xxl-12 text-start">
//               <div className=" spent_table_boxs  px-lg-5 px-1  py-4">
//                 <div className="" style={{ overflow: "auto", height: "50vh" }}>
//                   <table className="table table-borderless  text-center">
//                     <thead>
//                       <tr>
//                         <th scope="col" className="col-3 fw-semibold th_color">
//                           {t("referralAdress")}
//                         </th>
//                         <th scope="col" className="col-3 fw-semibold th_color">
//                           {t("spendUSDT")}
//                         </th>
//                         <th scope="col" className="col-3 fw-semibold th_color">
//                           {t("spendUSDACE")}
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {/* {spendData.map((data, index) => (
//                         <tr key={index} className="row_style">
//                           <td className="border_radius_left">{index + 1}.</td>
//                           <td>{data.usdt}$</td>
//                           <td className="border_radius_right">{data.usAce}$</td>
//                         </tr>
//                       ))} */}
//                       <tr className="row_style">
//                         <td>{acc}</td>
//                         <td>$ {commissionHistory.usdtValue}</td>
//                         <td>$ {commissionHistory.usdaceValue}</td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     </div>
//   );
// };

// export default Spent_Table;

import React, { useEffect, useState } from "react";
import "./spent_table.css";
import "../../App.css";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
// import PolygonIcon from "../../assets/images/Polygon.svg";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { useTranslation } from "react-i18next";

import { contractAddress, contractAddressAbi } from "../utils/contractaddress";
import { connectionAction } from "../../Redux/connection/actions";
function Spent_Table() {
  const { t, i18n } = useTranslation();
  const [refLevel, setRefLevel] = useState([]);
  const [commissionInfo, setCommissionInfo] = useState([0, 0]);
  const [isLoading, setIsLoading] = useState(false);

  // let acc = "0x70C0Fb7462F6658A9d4D7d6Af2d2e0C1fD8CE365";
  const { acc } = useSelector((state) => state.connect);

  const dispatch = useDispatch();
  const connectWallet = () => {
    dispatch(connectionAction());
  };
  const ReferralLevel = async () => {
    const web3 = window.web3;
    try {
      if (acc === "No Wallet") {
        console.log("No Wallet");
      } else if (acc === "Wrong Network") {
        console.log("Wrong Wallet");
      } else if (acc === "Connect Wallet") {
        console.log("Connect Wallet");
      } else {
        setIsLoading(true);
        let contract = new web3.eth.Contract(
          contractAddressAbi,
          contractAddress
        );
        let counts = [];
        for (let level = 1; level <= 10; level++) {
          let count = await contract.methods.userCount(acc, level).call();

          let arr = [];
          for (let i = 1; i <= count; i++) {
            let obj = {};
            let refferralAddress = await contract.methods
              .userReferral(acc, level, i)
              .call();
            let totalUSDACESpent = await contract.methods
              .totalUSDACESpent(refferralAddress)
              .call();
            totalUSDACESpent = Number(
              web3.utils.fromWei(totalUSDACESpent)
            ).toLocaleString();
            let totalUSDTSpent = await contract.methods
              .totalUSDTSpent(refferralAddress)
              .call();
            totalUSDTSpent = Number(
              web3.utils.fromWei(totalUSDTSpent)
            ).toLocaleString();

            obj.refferralAddress = refferralAddress;
            obj.totalUSDACESpent = totalUSDACESpent;
            obj.totalUSDTSpent = totalUSDTSpent;
            arr.push(obj);
          }
          counts.push(arr);
        }
        console.log("counts", counts);
        setRefLevel(counts);
        setIsLoading(false);
      }
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };
  // const commissionDetail = async () => {
  //   const web3 = window.web3;
  //   try {
  //     if (acc === "No Wallet") {
  //       console.log("No Wallet");
  //     } else if (acc === "Wrong Network") {
  //       console.log("Wrong Wallet");
  //     } else if (acc === "Connect Wallet") {
  //       console.log("Connect Wallet");
  //     } else {
  //       let contract = new web3.eth.Contract(
  //         contractAddressAbi,
  //         contractAddress
  //       );
  //       let { 0: usdt, 1: usdac } = await contract.methods
  //         .TotalClaimed(acc)
  //         .call();
  //       let arr = [];
  //       arr.push(Number(web3.utils.fromWei(usdt)).toLocaleString());
  //       arr.push(Number(web3.utils.fromWei(usdac)).toLocaleString());
  //       setCommissionInfo(arr);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // const userWithdraw = async () => {
  //   const web3 = window.web3;
  //   try {
  //     console.log(commissionInfo[0] === 0);
  //     if (acc === "No Wallet") {
  //       toast.info(t("connectWallet"));
  //     } else if (acc === "Wrong Network") {
  //       toast.info(t("connectWallet"));
  //     } else if (acc === "Connect Wallet") {
  //       toast.info(t("connectWallet"));
  //     } else {
  //       let contract = new web3.eth.Contract(
  //         contractAddressAbi,
  //         contractAddress
  //       );
  //       let commission;
  //       if (commissionInfo[0] == 0 && commissionInfo[1] == 0) {
  //         toast.info("Your Commission is 0");
  //       } else {
  //         let maxWithdrwa = await contract.methods.maxWithdraw(acc).call();
  //         maxWithdrwa = Number(web3.utils.fromWei(maxWithdrwa));
  //         let { 0: usdt } = await contract.methods.TotalClaimed(acc).call();
  //         let totalUSDTCommission = await contract.methods
  //           .totalUSDTCommission(acc)
  //           .call();
  //         totalUSDTCommission = Number(web3.utils.fromWei(totalUSDTCommission));
  //         let total = totalUSDTCommission + Number(web3.utils.fromWei(usdt));
  //         if (total <= maxWithdrwa) {
  //           commission = await contract.methods
  //             .claimedCommission()
  //             .send({ from: acc });
  //           commissionDetail();
  //           connectWallet();
  //         } else {
  //           toast.error("your commission limit have exceded");
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };
  useEffect(() => {
    ReferralLevel();
    // commissionDetail();
  }, [acc]);

  return (
    <div className="">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-10 mt-3 ">
            <div className="row d-flex justify-content-center">
              <div className="spent_table_boxs  px-lg-5 px-1  py-4">
                <table className="table table-borderless  text-center">
                  <thead>
                    <tr>
                      <th scope="col" className="col-3 fw-semibold th_color">
                        {t("referralAddress")}
                      </th>
                      <th scope="col" className="col-3 fw-semibold th_color">
                        USDT
                      </th>
                      <th scope="col" className="col-3 fw-semibold th_color">
                        USDACE$
                      </th>
                    </tr>
                  </thead>
                </table>
                {refLevel?.map((level, index) => {
                  return (
                    <div className="main_acc">
                      <Accordion flush className="Acc_header">
                        <Accordion.Item eventKey={index} className="Acc_item">
                          <Accordion.Header className="text-center Acc_header">
                            {i18n.language == "en"
                              ? `${t("level")} ${index + 1}`
                              : `${index + 1} ${t("level")}`}
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="table-reponsive shadow-none">
                              <Table className="table " responsive="sm">
                                <thead className="Acc_head">
                                  <tr className="text-center Acc_row">
                                    <th className="col-3 fw-semibold th_color">
                                      {t("referralAddress")}
                                    </th>
                                    <th className="col-3 fw-semibold th_color">
                                      USDT
                                    </th>
                                    <th className="col-3 fw-semibold th_color">
                                      USDACE$
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {level.length > 0 ? (
                                    level.map((item) => {
                                      return (
                                        <tr className="text-center row_style Acc_row shadow-none">
                                          <td>{item.refferralAddress}</td>
                                          <td>{item.totalUSDTSpent}</td>
                                          <td>{item.totalUSDACESpent}</td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr className="Acc_row">
                                      <td colSpan={3}>N.A</td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {/* <div className="row d-flex justify-content-center">
            <div className="col-md-10 mt-3">
              <div className="row ">
                <div className="col-md-12 table-background">
                  <div className="row d-flex justify-content-center mt-4 mb-4">
                    <div className="col-md-10 col-10 box-backgorund mb-3">
                      <div className="d-flex justify-content-between">
                        <div className="p-2 text-unit">USDT</div>
                        <div className="p-2 text-value  ">
                          {commissionInfo[0]}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-10 col-10 box-backgorund mb-3">
                      <div className="d-flex justify-content-between">
                        <div className="p-2 text-unit">USDACE$</div>
                        <div className="p-2 text-value  ">
                          {commissionInfo[1]}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-10 col-10">
                      <div className="d-grid gap-2 mt-3">
                        <button
                          className="btn btn-wallet"
                          type="button"
                          onClick={() => {
                            userWithdraw();
                          }}
                        >
                          {t("withdrawCommission")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
export default Spent_Table;
